import React, { useState, useEffect, useCallback } from 'react';

const Hero = ({ showBrochure: externalShowBrochure, setShowBrochure: externalSetShowBrochure }) => {
    // Use external state if provided, otherwise use internal state
    const [internalShowBrochure, setInternalShowBrochure] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    // Determine which state to use
    const showBrochure = externalShowBrochure !== undefined ? externalShowBrochure : internalShowBrochure;
    const setShowBrochure = externalSetShowBrochure !== undefined ? externalSetShowBrochure : setInternalShowBrochure;

    // Wrap openPopup in useCallback to prevent unnecessary recreations
    const openPopup = useCallback(() => {
        console.log('Opening popup from Hero');
        setShowBrochure(true);
        setTimeout(() => setIsVisible(true), 50);
    }, [setShowBrochure]);

    const closePopup = () => {
        console.log('Closing popup');
        setIsVisible(false);
        setTimeout(() => {
            setShowBrochure(false);
        }, 300);
    };

    // Show brochure popup after 3 seconds with smooth animation
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowBrochure(true);
            // Small delay to trigger CSS animation
            setTimeout(() => setIsVisible(true), 50);
        }, 3000);

        return () => clearTimeout(timer);
    }, [setShowBrochure]);

    const scrollToForm = () => {
        document.getElementById('enquiry-form').scrollIntoView({
            behavior: 'smooth'
        });
        closePopup();
    };

    const scrollToFeedback = () => {
        document.getElementById('feedback').scrollIntoView({
            behavior: 'smooth'
        });
    };

    const openWhatsApp = () => {
        const message = "Hello! I'm interested in Chemistry tuition for CBSE classes. Could you please provide more information?";
        const phone = "+919790885125";
        window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
    };

    const makeCall = () => {
        window.open('tel:+919790885125', '_self');
    };

    // const downloadBrochure = () => {
    //     // Replace with actual brochure download link
    //     const brochureUrl = "/brochures/admission-brochure.pdf";
    //     window.open(brochureUrl, '_blank');
    //     closePopup();
    // };

    // If external control is provided, expose openPopup function
    useEffect(() => {
        if (externalSetShowBrochure) {
            // Expose openPopup to window for navbar access (simple solution)
            window.openAdmissionPopup = openPopup;
        }
    }, [externalSetShowBrochure, openPopup]); // Now openPopup is stable due to useCallback

    return (
        <>
            {/* Admission Brochure Popup */}
            {showBrochure && (
                <div className={`brochure-popup-overlay ${isVisible ? 'visible' : ''}`} onClick={closePopup}>
                    <div className={`brochure-popup ${isVisible ? 'visible' : ''}`} onClick={(e) => e.stopPropagation()}>
                        <button
                            className="popup-close-btn"
                            onClick={closePopup}
                        >
                            ×
                        </button>

                        <div className="popup-content">
                            <div className="popup-header">
                                <div className="popup-badge">Admissions Open for 2027-2028</div>
                                <h2>Start Your Chemistry Journey</h2>
                                <p>Join the best Chemistry tuition for CBSE Classes 11 & 12</p>
                            </div>

                            <div className="popup-actions">
                                <button
                                    className="btn btn-primary"
                                    onClick={scrollToForm}
                                >
                                    Enroll Now
                                </button>
                                <button className="whatsapp-btn popup-btn success" onClick={openWhatsApp} title="WhatsApp Now">
                                    <i className="fab fa-whatsapp"></i>
                                    WhatsApp Now
                                </button>
                            </div>

                            <div className="popup-footer">
                                <span>Limited seats available</span>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Floating Contact Sidebar */}
            <div className="floating-contact-sidebar">
                <div className="contact-buttons">
                    <button className="floating-btn call-btn" onClick={makeCall} title="Call Now">
                        <i className="fas fa-phone"></i>
                        <span className="btn-tooltip">Call Now</span>
                    </button>

                    <button className="floating-btn whatsapp-btn" onClick={openWhatsApp} title="WhatsApp Now">
                        <i className="fab fa-whatsapp"></i>
                        <span className="btn-tooltip">WhatsApp</span>
                    </button>
                </div>
            </div>

            <section className="hero" id="hero">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-logo-section">
                            <div className="logo-container">
                                <img
                                    src="/images/logo.png"
                                    alt="SriChem Logo"
                                    className="logo-img"
                                />
                                <div className="logo-brand">
                                    <div className="logo-tagline">Building Strong Bonds with Chemistry</div>
                                </div>
                            </div>
                        </div>

                        <div className="hero-text-section">
                            <p className="hero-subtitle">
                                Best Chemistry Tuition for CBSE Classes 11 & 12
                            </p>

                            <div className="key-highlights">
                                <div className="highlight-card">
                                    <span>13+ Years Experience | Graduate from Anna University</span>
                                </div>
                                <div className="highlight-card">
                                    <span>Online & Offline Classes</span>
                                </div>
                                <div className="highlight-card">
                                    <span>Regular Practice Tests | Printed Materials | Test Feedbacks </span>
                                </div>
                            </div>

                            <div className="hero-buttons">
                                <button className="btn btn-primary" onClick={scrollToForm}>
                                    Enquire Now
                                </button>
                                <button className="btn btn-secondary" onClick={scrollToFeedback}>
                                    Hear from Students
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Hero;